<template>
  <v-dialog v-model="dialog" content-class="invoice-dialog" @click:outside="close" @keydown.esc="close" scrollable>
    <v-toolbar>
      <v-spacer></v-spacer>
      <v-menu v-model="emailCard.show" :close-on-content-click="false" :nudge-width="200" offset-x>
        <template v-slot:activator="{ on }">
          <v-btn v-if="isDraft" rounded outlined color="success" v-on="on">
            <v-icon left>mdi-email-outline</v-icon> Send
          </v-btn>
          <v-btn v-else rounded outlined color="info" v-on="on">
            <v-icon left>mdi-email-outline</v-icon> Send again
          </v-btn>
        </template>
        <v-card>
          <v-card-text>
            <v-text-field label="From" disabled v-model="emailCard.from"></v-text-field>
            <v-text-field label="To" v-model="emailCard.to"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn small @click="send" color="success">
              <v-icon left>email</v-icon> Send
            </v-btn>
            <v-btn small @click="emailCard.show = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <v-btn rounded outlined @click="download"  color="success" class="ml-2">
        <v-icon left>save_alt</v-icon> Download
      </v-btn>
      <v-btn icon @click="close"><v-icon>clear</v-icon></v-btn>
    </v-toolbar>
    <v-card flat :loading="loading" class="invoice-preview-dialog-card" ref="invoiceCard">
      <v-card-text style="border: 1px solid #ddd; height:920px;">
        <v-form v-if="loaded" v-model="valid">
          <v-container fluid>
            <v-row no-gutters>
              <v-col cols="12">
                <v-container fluid>
                  <v-row no-gutters>
                    <v-col cols="12" class="text-center">
                      <img :src="assetRoot + '/Logo.jpg'" style="width:32px; margin-left:-16px"><br>
                    </v-col>
                    <v-col cols="12" class="text-center" style="margin-bottom:64px">
                      <span class="ml-4" style="font-size:.8em">Powered by <a href="https://taxteam.nz">taxteam.nz</a></span>
                    </v-col>

                    <v-col cols="12" class="mb-2 text-right"><div style="font-size:3em">TAX INVOICE</div></v-col>
                    <v-col cols="12" class="text-right">
                      <label>GST: </label>
                      <span v-html="entity.ird"></span>
                    </v-col>
                    <v-col cols="12" class="text-right">
                      <span v-html="entity.name"></span>
                    </v-col>
                    <v-col cols="12" class="text-right">
                      <span v-html="(entity.mailing_address && entity.mailing_address.formatted) || (entity.address && entity.address.formatted)"></span>
                    </v-col>
                    <v-col cols="12" class="text-right">
                      <span v-html="entity.email"></span>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider class="mt-4"></v-divider>
              </v-col>
              <v-col cols="6">
                <v-container v-if="customer && customer.id">
                  <v-row no-gutters class="customer-info">
                    <v-col cols="12"><b>Bill to</b></v-col>
                    <v-col cols="12" v-html="customer.name"></v-col>
                    <v-col cols="12" v-html="customer.address"></v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-col cols="6">
                <v-container fluid>
                  <v-row no-gutters>
                    <v-col cols="8" class="text-right pr-4">Invoice number:</v-col>
                    <v-col cols="4"><span v-html="invoiceNo"></span></v-col>
                    <v-col cols="8" class="text-right pr-4">P.O. number:</v-col>
                    <v-col cols="4"><span v-html="poNumber"></span></v-col>
                    <v-col cols="8" class="text-right pr-4">Invoice date:</v-col>
                    <v-col cols="4">{{ issueDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}</v-col>
                    <v-col cols="8" class="text-right pr-4">Due date:</v-col>
                    <v-col cols="4">{{ dueDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}</v-col>
                    <v-col cols="8" class="text-right pr-4">Amount Due:</v-col>
                    <v-col cols="4">${{ amountToPay.toFixed(2) }}</v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <v-list>
                  <v-list-item>
                    <v-list-item-title style="color:white; background-color:#444;">
                      <v-container>
                        <v-row no-gutters style="font-size:.9em; font-weight:bold;">
                          <v-col cols="3">Items</v-col>
                          <v-col cols="4">Description</v-col>
                          <v-col cols="1">Qty</v-col>
                          <v-col cols="1" class="text-right">Price</v-col>
                          <v-col offset="1" cols="2">Amount</v-col>
                        </v-row>
                      </v-container>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-container>
                      <v-row no-gutters v-for="(item, idx) in invoiceItems" style="font-size:.9em;" :key="idx">
                        <v-col cols="3">{{ item.name }}</v-col>
                        <v-col cols="4"><div class="pr-2" v-html="item.description"></div></v-col>
                        <v-col cols="1"><div class="pr-2" v-html="item.quantity"></div></v-col>
                        <v-col cols="1" class="text-right"><div class="pr-2" v-html="'$'+item.price.toFixed(2)"></div></v-col>
                        <v-col offset="1" cols="2">
                          <div class="pr-2" v-html="'$'+item.amount.toFixed(2)"></div>
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="mt-4" style="font-size:.9em; border-top:3px solid #ccc">
                        <v-col cols="9" class="text-right"><b>Total:</b></v-col>
                        <v-col offset="1" cols="2" v-html="'$'+totalAmount.toFixed(2)"></v-col>
                        <v-col cols="9" class="text-right"><b>GST:</b></v-col>
                        <v-col offset="1" cols="2" v-html="'$'+totalGst.toFixed(2)"></v-col>
                        <template v-for="payment in paymentHistory">
                          <v-col cols="9" class="text-right" :key="payment.id">
                            Payment on {{ payment.paid_time.split('.')[0].replace('T', ' ') | dateParse() | dateFormat('DD/MM/YYYY') }}:
                          </v-col>
                          <v-col offset="1" cols="2" :key="'amount-' + payment.id" v-html="'$'+payment.amount"></v-col>
                        </template>
                        <v-col cols="9" class="text-right"><b>Amount Due:</b></v-col>
                        <v-col offset="1" cols="2" v-html="'$'+amountToPay.toFixed(2)"></v-col>
                      </v-row>
                    </v-container>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <v-row no-gutters class="pa-6 mt-8">
              <v-col cols="12"><b>NOTES</b></v-col>
              <v-col cols="12">
                <div v-html="(notes || '').replaceAll('\n', '<br/>')"></div>
              </v-col>
              <v-col cols="12" v-if="entity.invoice_notes">
                <div v-html="(entity.invoice_notes || '').replaceAll('\n', '<br/>')"></div>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { namespace, Getter } from 'vuex-class'
import EditForm from '@/components/public/EditForm'
import InvoiceService from '@/services/InvoiceService'

const SubModule = namespace('invoice')

@Component({
  components: {
    EditForm
  }
})
export default class InvoiceDetail extends Vue {
  dialog = false
  loaded = false
  loading = false
  itemId = null
  valid = false
  poNumber = null
  issueDate = null
  dueDate = null
  totalAmount = 0
  amountToPay = 0
  totalGst = 0
  notes = null
  invoiceItems = []
  customer = {}
  paymentHistory = []
  emailCard = {
    show: false,
    from: 'invoice-generator@taxteam.co.nz',
    to: null
  }
  isDraft = true

  @Getter entity
  @Getter assetRoot
  @SubModule.Getter fields
  @SubModule.Getter service
  @SubModule.Getter invoiceNo

  @SubModule.Action setFieldItemsNoSend

  close (evt, data = undefined) {
    if (data !== undefined) {
      this.$emit('close-preview', data)
    }
    this.dialog = false
  }

  load (pk) {
    this.loaded = false
    this.itemId = pk
    this.isDraft = true
    this.service.get(pk)
      .then(resp => {
        const data = resp.data
        const items = Object.keys(data).map(k => {
          return { name: k, value: data[k] }
        })
        this.setFieldItemsNoSend(items)
        this.poNumber = data.po_number
        this.issueDate = data.issue_time
        this.dueDate = data.due_date
        this.totalAmount = data.amount
        this.amountToPay = data.amount_to_pay
        this.totalGst = data.gst
        this.customer = data.customer
        this.notes = data.notes
        this.invoiceItems = data.items
        this.paymentHistory = data.payments
        this.isDraft = data.is_draft

        this.emailCard.to = this.customer.email

        this.loaded = true
        this.dialog = true
      })
      .catch(err => {
        const resp = err.response
        this.$emit('show-message', {
          message: 'Failed to get detail',
          error: resp.data.detail || resp.statusText
        })
      })
  }

  send () {
    InvoiceService.sendEmail(this.itemId, { from: this.emailCard.from, to: this.emailCard.to })
      .then(resp => {
        this.$emit('send-invoice')
        this.close(null, { color: 'success', message: 'Sent the invoice!' })
      })
      .catch(err => {
        this.close(null, {
          message: 'Failed to send invoice:',
          error: err
        })
      })
  }

  download () {
    window.open(`/api/v1/invoice/invoice/${this.itemId}/download_pdf/`)
  }
}
</script>

<style lang="scss">
.active-account {
  border-left: 2px solid blue;
}
.invoice-dialog {
  position: fixed;
  margin: 0;
  width: auto;
  top: 0; left: 20%; bottom: 0; right: 0;
  max-height: 100% !important;
  @media screen and (max-width: 600px) {
    left: 10%;
  }
}
.invoice-preview-dialog-card {
  border-radius: 0 !important;
  position: absolute;
  top: 64px; bottom: 0;
  left: 50%; right: 0;
  width: 720px;
  margin-left:-360px;
  @media screen and (max-width: 960px) {
    top: 56px;
  }
}
.invoice-form .v-input--checkbox {
  margin-left: 16px;
}
.invoice-input {
  margin-top: -13px;
  font-size: 1em;
  min-width: 74px;
}
.customer-info {
  border: none;
  margin:-19px -10px;
  border-radius:0 0 5px 5px;
  padding: 16px;
  height: 109px
}
</style>
